import React from 'react';

import { Tooltip } from 'components/antd';

import styles from './FinanceBaseValue.module.scss';

interface FinanceBaseValueProps {
	value: React.ReactElement;
	showTooltip: boolean;
}
class FinanceBaseValue extends React.Component<FinanceBaseValueProps> {
	render() {
		const { value, showTooltip } = this.props;
		return (
			<Tooltip
				title={
					showTooltip
						? 'Was modified due to bank holidays or out of hours rules'
						: undefined
				}
				placement="bottom"
			>
				<span className={showTooltip ? styles.valueWithStar : ''}>
					{value}
					{showTooltip && '*'}
				</span>
			</Tooltip>
		);
	}
}

export default FinanceBaseValue;
